<h2 mat-dialog-title>¿Qué es el Certificado MiPyME y cómo lo tramito?</h2>
<mat-dialog-content class="mat-typography">
    <h3>En el <b>FTyC</b> financiamos a las <b>PyMEs</b> con plazos y tasas acordes a la categoría definida en el <b>Certificado
        MiPyME</b>. </h3>
    <p>- Si querés más información sobre el <b>Certificado MiPyME</b> y los beneficios de tenerlo te recomendamos
        ingresar <a style="color: #ac1a1f !important;" href="https://www.argentina.gob.ar/produccion/registrar-una-pyme/que-es-una-pyme"
                    target="_blank">aquí.</a></p>
    <p>- Si sos una <b>MiPyME</b> y todavía no tenés el certificado, tramitalo ingresando <a style="color: #ac1a1f !important;"
            href="https://www.argentina.gob.ar/servicio/registrar-una-pyme" target="_blank">aquí.</a></p>
</mat-dialog-content>
<mat-dialog-actions align="center">
    <button mat-button mat-dialog-close class="boton-rojo-ftyc">Ok</button>
</mat-dialog-actions>
